import { useEffect, useState } from "react";
import Router from "next/router";
import Cookie from "js-cookie";

import usePageFlow from "@component/flows/hooks/usePageFlow";
import PageFlow, { useRouterLocation } from "@component/flows/PageFlow";
import { Plan } from "@feature/subscription";
import UltimateSelectPlan from "@page/dashboard/store/_views/ultimate_plan";

export default function OnboardingWithPlan() {
  const location = useRouterLocation("/onboarding-with-plan");
  const { flowController, registerPage } = usePageFlow();

  const [plans, setPlans] = useState<Plan[]>();

  const planQueryToKeys = {
    prem: ["premium"],
    ult: ["ultimate"],
    prut: ["ultimate", "premium"],
  };

  useEffect(() => {
    const planQuery = Cookie.get("plan");
    if (!planQuery) {
      Router.push("/onboarding");
      return;
    }
    setPlans(planQueryToKeys[planQuery]);
  }, []);

  return (
    <PageFlow
      flowController={flowController}
      location={location}
      onComplete={() => {
        Router.push("/onboarding");
      }}
    >
      <UltimateSelectPlan {...registerPage("/select-plan")} plans={plans} />
    </PageFlow>
  );
}
